import { html, css, LitElement } from "lit-element";
import {store} from "@stofloos/stores/store";
import {connect} from "pwa-helpers/connect-mixin.js";

import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import "@stofloos/components/atoms/user/user-label";
import {searchAll} from "@stofloos/actions/requests";
import {localize} from "@stofloos/actions/localize";
import {openDialog, closeDialog} from "@stofloos/actions/dialog";
import {unsetQueryFilter} from "@stofloos/actions/requests";
import {readObjects} from "@stofloos/actions/crud";
import find from "lodash-es/find";

// language=css
const swHeaderFiltersStyle = css`
    :host {
        display: block;
        --sw-dialog-simple-width: 300px;
        --sw-dialog-simple-modal-top: 40px;
        --sw-dialog-simple-radius: 12px;
        --sw-dialog-simple-modal-left: 0;
        --sw-dialog-simple-background: transparent;
        --sw-dialog-simple-animation-time: 100ms;
	}
    
    sw-icon {
        --sw-icon-width:  auto;
        --sw-icon-height: 20px;
        --sw-icon-color: var(--app-primary);
        width: 20px;
        height: 20px;
    }
    
    .input-simple {
        margin-top: 20px;
        height: 30px;
        opacity: 0.5;
        background-color: var(--app-lightgrey);
        border-radius: 25px;
        padding: 5px 20px;
        min-width: 200px;
    }
    
    .input-simple sw-icon {
        margin-right: 10px;
        --sw-icon-width: 12px;
    }
    
    .input-simple input {
        opacity: 1;
        background-color: transparent;
        border: none;
        height: 100%;
    }

    .input-simple input:focus {
        outline: none;
    }
    
    .input-simple:focus-within {
        box-shadow: 0 0 8px var(--app-accent, rgba(0, 0, 0, 0.15));
    }
    
    .filter-item-container {
        position: relative;
    }
    
    .filter-item {
        white-space: nowrap;
        display: block;
        border-radius: 16px;
        padding: 4px 8px;
        height: 20px;
        line-height: 20px;
        border: 1px solid var(--app-primary);
        margin-right: 8px;
        cursor: pointer;
        opacity: .67;
    }  
    .filter-item.active {
        opacity: 1;
        font-weight: bold;
        padding: 3px 8px;
        border: 2px solid var(--app-primary);
    }
    .filter-item:hover {
        opacity: 1;
    }
`;

export class StofwareFilterDefault extends connect(store)(LitElement) {
    static get properties() {
        return {
            endpoint: String,
            filterValue: String,
            filterOption: {type: Object}
        };
    }
    static get styles() {
        return [LayoutFlex, swHeaderFiltersStyle]
    }

    stateChanged(state) {
            if(state.requests[this.endpoint].queryFilters && state.requests[this.endpoint].queryFilters.length > 0) {
                const queryFilters = state.requests[this.endpoint].queryFilters;
                const name = this.filterOption.name;
                const eqObject = find(queryFilters, ['id', name+"eq"]);
                const ilikeObject = find(queryFilters, ['id', name+"ilike"]);
                if(eqObject) {
                    this.filterValue = eqObject.value;
                }
                if(ilikeObject) {
                    this.filterValue = ilikeObject.value.replace(/%/g, '');
                }
            }
    }

    constructor() {
        super();
    }

    setFilter(e){
        store.dispatch(searchAll(e));
        this.filterValue = e.target.value;
    }

    clearFilter(name) {
        store.dispatch(unsetQueryFilter(this.endpoint, name+"eq"));
        store.dispatch(unsetQueryFilter(this.endpoint, name+"ilike"));
        store.dispatch(readObjects(this.endpoint));
        store.dispatch(closeDialog('filters'+name));
        this.shadowRoot.getElementById("input"+name).value = "";
        this.filterValue = "";
    }

    render() {
        // language=HTML
        return html`
            <div class="filter-item-container">
                <span class="filter-item ${this.filterValue ? "active" : ""}" @click="${() => store.dispatch(openDialog('filters'+this.filterOption.name))}">
                    ${localize([this.endpoint+"::"+this.filterOption.name,"properties::"+this.filterOption.name])}${this.filterValue ? ": "+this.filterValue: ""}
                </span>
                <dialog-simple dialogId="filters${this.filterOption.name}" relative close>
                     <div class="input-simple layout horizontal center flex">
                        <sw-icon set="fas" icon="search"></sw-icon>
                        ${this.filterOption.type === "text" ? html`
                            <input id="input${this.filterOption.name}" class="flex" data-requestid="${this.endpoint}" string-search data-columnstring="${this.filterOption.name}" @keyup="${e => this.setFilter(e)}" type="text" placeholder="Zoek op ${localize([this.endpoint+"."+this.filterOption.name,"properties::"+this.filterOption.name])}">
                        ` : ``}
                         ${this.filterOption.type === "number" ? html`
                            <input id="input${this.filterOption.name}" class="flex" data-requestid="${this.endpoint}" data-columnnumber="${this.filterOption.name}" @keyup="${e => this.setFilter(e)}" type="text" placeholder="Zoek op ${localize([this.endpoint+"."+this.filterOption.name,"properties::"+this.filterOption.name])}">
                        ` : ``}
                    </div>
                    
                     <div class=" justified layout horizontal center flex">
                        <button-text @click="${() => this.clearFilter(this.filterOption.name)}" label="wissen"></button-text>
                        <button-contained @click="${() => store.dispatch(closeDialog('filters'+this.filterOption.name))}}" label="opslaan"></button-contained>
                     </div>
                </dialog-simple>
            </div>
		`;
    }

}

window.customElements.define("sw-filter-default", StofwareFilterDefault);
